import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { DialogActions } from "@material-ui/core";
import { useFormikContext } from "formik";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchOutlet from "../../outlets/searchOutlet";
import PosHeader from "./posHeader";
import PosDeliveryAddress from "./posDeliveryAddress";
import { Editor } from "primereact/editor";
import SalesReturnForm from "../../sales-return/salesReturnForm/salesReturnForm";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import PosPayment from "./posPayment";
import SalesPOSList from "../salesPosList";
function PosContent({ history, countries }) {
  const { values, setFieldValue, handleSubmit } = useFormikContext();
  const [openSearchOutlet, setOpenSearchOutlet] = useState(true);
  const [openAddress, setOpenAddress] = useState(false);
  const [openSalesNote, setOpenSalesNote] = useState(false);
  const [openSalesReturn, setOpenSalesReturn] = useState(false);
  const [openPaymentForm, setOpenPaymentForm] = useState(false);

  return (
    <React.Fragment>
      <PageSubHeader
        title={`Point of Sales ${values.outletName}`}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/pos",
            title: "Point of Sales " + values.outletName,
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
          {
            title: "Sales Return",
            color: "dark",
            icon: "fas fa-truck-loading",
            onClick: () => {
              setOpenSalesReturn(true);
            },
          },
        ]}
      />
      <ContentLayout>
        <div className="tabview">
          <div className="card">
            <TabView className="tabview" scrollable>
              <TabPanel
                header="Point Of Sales"
                rightIcon="fas fa-cash-register"
              >
                <PosHeader
                  outletID={values.outletID}
                  setOpenPaymentForm={setOpenPaymentForm}
                  setOpenAddress={setOpenAddress}
                  setOpenSalesNote={setOpenSalesNote}
                />
              </TabPanel>
              <TabPanel header="Sales List" rightIcon="fas fa-receipt">
                <SalesPOSList outletID={values.outletID} />
              </TabPanel>
            </TabView>
          </div>
        </div>
      </ContentLayout>
      <DialogLayout
        open={openPaymentForm}
        title="Point of Sales Payment"
        onCloseDialog={() => {
          setOpenPaymentForm(false);
        }}
        maxWIdth="md"
      >
        <PosPayment />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenPaymentForm(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="submit"
            className="btn btn-label-success btn-md btn-pill btn-bold"
            onClick={handleSubmit}
          >
            <i className="fas fa-save"></i>
            Save
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openAddress}
        title="Delivery Address"
        onCloseDialog={() => {
          setOpenAddress(false);
        }}
        maxWIdth="md"
      >
        <PosDeliveryAddress
          countries={countries}
          onCloseDialog={() => {
            setOpenAddress(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSearchOutlet}
        onCloseDialog={() => {
          history.push("/menu");
        }}
        title="Select Outlet"
        maxWIdth="lg"
      >
        <SearchOutlet
          onSelectOutlet={(outlet) => {
            setFieldValue("outlet", outlet);
            setFieldValue("outletID", outlet.ID);
            setFieldValue("outletName", outlet.outletName);
            setFieldValue("currencyID", outlet.currencyID);
            setFieldValue("currencyCode", outlet.currency.currencyCode);
            setOpenSearchOutlet(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSalesNote}
        title="Sales Note"
        onCloseDialog={() => {
          setOpenSalesNote(false);
        }}
        maxWIdth="sm"
      >
        <Editor
          style={{ height: "200px" }}
          onTextChange={(e) => {
            setFieldValue("salesNote", e.htmlValue);
          }}
          value={values.salesNote}
          placeholder="Type your notes here..."
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSalesNote(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSalesReturn}
        title="Sales Return"
        onCloseDialog={() => {
          setOpenSalesReturn(false);
        }}
        maxWIdth="lg"
      >
        <SalesReturnForm
          outletID={values.outletID}
          onCloseSalesReturn={() => {
            setOpenSalesReturn(false);
          }}
          onConfirmSave={() => {
            setOpenSalesReturn(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default PosContent;
